export const reOrgStatusTypeConstants = {
	GetPaged: {
		SUCCESS : 'GET_PAGED_ORG_STATUS_SUCCESS',
		REQUEST : 'GET_PAGED_ORG_STATUS_REQUEST',
		FAILURE : 'GET_PAGED_ORG_STATUS_FAILURE'
	},
	GetPagedAll: {
		REQUEST : 'GET_PAGED_ALL_ORG_STATUS_REQUEST',
		SUCCESS : 'GET_PAGED_ALL_ORG_STATUS_SUCCESS',
		FAILURE : 'GET_PAGED_ALL_ORG_STATUS_FAILURE'
	},
	GetList: {
		REQUEST : 'GET_LIST_ORG_STATUS_REQUEST',
		SUCCESS : 'GET_LIST_ORG_STATUS_SUCCESS',
		FAILURE : 'GET_LIST_ORG_STATUS_FAILURE'
	},
	Create: {
		REQUEST : 'CREATE_ORG_STATUS_REQUEST',
		SUCCESS : 'CREATE_ORG_STATUS_SUCCESS',
		FAILURE : 'CREATE_ORG_STATUS_FAILURE'
	},
	Delete: {
		REQUEST : 'DELETE_ORG_STATUS_REQUEST',
		SUCCESS : 'DELETE_ORG_STATUS_SUCCESS',
		FAILURE : 'DELETE_ORG_STATUS_FAILURE'
	},
	Update: {
		REQUEST : 'UPDATE_ORG_STATUS_REQUEST',
		SUCCESS : 'UPDATE_ORG_STATUS_SUCCESS',
		FAILURE : 'UPDATE_ORG_STATUS_FAILURE'
	},
	Restore: {
		REQUEST : 'RESTORE_ORG_STATUS_REQUEST',
		SUCCESS : 'RESTORE_ORG_STATUS_SUCCESS',
		FAILURE : 'RESTORE_ORG_STATUS_FAILURE'
	},
	CLEAR: 'CLEAR_ORG_STATUS'
}